import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import { Eyebrow } from 'components/Typography'
import FormLabel from '../FormLabel'
import FormErrorMessage from '../FormErrorMessage'
import { Wrapper, InputText } from './FormText.style'

const FormText = ({
  label,
  value,
  name,
  required,
  hasError,
  errorMessage,
  isDisabled,
  handleChange,
  onKeyDown,
  autoComplete,
}) => {
  return (
    <Wrapper>
      <FormLabel hasError={hasError} isDisabled={isDisabled}>
        <Eyebrow color={theme.colors.sagedark}>{label}</Eyebrow>
        <InputText
          type="text"
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          required={required}
          hasError={hasError}
          isDisabled={isDisabled}
          autoComplete={autoComplete}
        />
      </FormLabel>
      {hasError && <FormErrorMessage errorMessage={errorMessage} />}
    </Wrapper>
  )
}

FormText.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  autoComplete: PropTypes.string,
}

FormText.defaultProps = {
  value: '',
  required: false,
  hasError: false,
  errorMessage: '',
  isDisabled: false,
  autoComplete: '',
  onKeyDown: () => {},
}

export default FormText
